export default __webpack_public_path__ + "static/media/dashboard-profile.04d2bb55.svg";